const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速秒播',
    desc: '采用先进P2P加速和CDN分发技术，点击即播无需等待，高清画质流畅不卡顿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '全程无弹窗、无贴片、无插播广告，给你最干净纯粹的观影环境。',
  },
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P至4K多档清晰度，自适应带宽智能切换，画面细腻色彩饱满。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '热播剧集和最新电影同步更新，每日都有新鲜内容加入，永不剧荒。',
  },
  {
    icon: 'ri-device-line',
    title: '全设备适配',
    desc: '电脑、手机、平板完美适配，随时随地打开浏览器即可畅享高清影视。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么选择97影视？五大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-200 group cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-950">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}